import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from '@mui/material';
import { Button } from '@infoods/lifebase-ui';

import classes from './CongratulationsModal.module.scss';
import Stars from '../../../../../shared/assets/image/stars.png';

const CongratulationsModal = ({ open, onCloseHandler }) => {
  return (
    <Modal open={open} onClose={onCloseHandler}>
      <div className={classes.modalBox}>
        <img src={Stars} alt="star" />
        <h4>Congratulations </h4>
        <p>Your Registration User of Active Calendar is Successful</p>
        <Button variant="contained" fullWidth onClick={onCloseHandler}>
          Finish
        </Button>
      </div>
    </Modal>
  );
};

CongratulationsModal.propTypes = {
  open: PropTypes.bool,
  onCloseHandler: PropTypes.func,
};

export { CongratulationsModal };
